import angular from "angular";

/*****************************************************************************
 * Component: activity */
/**
 * @ngdoc     component
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.component:activity
 * @description
 * Component definition object for {@link activity}
 *****************************************************************************/
export const activityComponent = {
  require: { dialogCtrl: '^^fundraiserItemsDialog' },
  template:
    '<activity-items grid-data="$ctrl.gridData" total="$ctrl.actualTotal" for-costs="$ctrl.forCosts"></activity-items>',
  controller: ActivityController
}

/*****************************************************************************
 * Controller: ActivityController */
/**
 * @ngdoc     controller
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.activity.controller:ActivityController
 * @description
 * Main controller for {@link activity}
 *****************************************************************************/
/* @ngInject */ function ActivityController($injector, $scope) {
  var $ctrl = this;
  $ctrl.$onInit = $injector.invoke($onInit, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });
  $ctrl.setActivityDetail = $injector.invoke(setActivityDetail, null, {
    $ctrl: $ctrl
  });
  $ctrl.updateGrid = $injector.invoke(updateGrid, null, { $ctrl: $ctrl });

  /***************************************************************************
   * Flags
   ***************************************************************************/
  /** Cost Tab is active. */ $ctrl.forCosts;

  /***************************************************************************
   * Dataproviders
   ***************************************************************************/
  /** Actual costs for fundraiser. */ $ctrl.dpActualCosts = [];
  /** Actual sales for fundraiser. */ $ctrl.dpActualSales = [];
}

/*****************************************************************************
 * $onInit */
/**
 * @ngdoc    function
 * @name     $onInit
 * @methodOf csm.books.fundraisers.activity.controller:ActivityController
 * @description
 * Initialization callback function. The required dialogCtrl will be available
 * at this point for initialization purposes.
 *****************************************************************************/
/* @ngInject */ function $onInit($ctrl, $scope, TabType) {
  return function () {
    /*--------------------------------------*/
    /* Set dataproviders for activity items */
    /* and update the summary tab's values. */
    /*--------------------------------------*/
    $ctrl.dialogCtrl.setSummaryTotals();
    $ctrl.setActivityDetail();

    /*-----------------------------------------------------------------------*/
    /* Register a watch in here in $onInit when the dialogCtrl becomes       */
    /* available. When the active tab changes, update the grid dataprovider. */
    /*-----------------------------------------------------------------------*/
    $scope.$watch(
      function () {
        return $ctrl.dialogCtrl.activeTab;
      },
      function () {
        /*------------------------*/
        /* Is this tab for costs? */
        /*------------------------*/
        $ctrl.forCosts =
          $ctrl.dialogCtrl.getTabType() === TabType.ACTIVITY_COSTS;

        $ctrl.updateGrid();
      }
    );
  };
}

/*****************************************************************************
 * setActivityDetail */
/**
 * @ngdoc    function
 * @name     setActivityDetail
 * @methodOf csm.books.fundraisers.activity.controller:ActivityController
 * @description
 * Sets the activity detail information for the summary tab and populates the
 * cost and sales dataproviders.
 *****************************************************************************/
/* @ngInject */ function setActivityDetail($ctrl, Tools) {
  return function () {
    $ctrl.dialogCtrl.summary.actualCosts = 0;
    $ctrl.dialogCtrl.summary.actualSales = 0;
    $ctrl.dpActualCosts = [];
    $ctrl.dpActualSales = [];

    angular.forEach($ctrl.dialogCtrl.dpActualItems, function (cd) {
      if (cd.isCost) {
        $ctrl.dpActualCosts.push(cd);
        $ctrl.dialogCtrl.summary.actualCosts += cd.amount;
      } else {
        $ctrl.dpActualSales.push(cd);
        $ctrl.dialogCtrl.summary.actualSales += cd.amount;
      }
    });

    /*-------------------------*/
    /* Adjust for any rounding */
    /*-------------------------*/
    $ctrl.dialogCtrl.summary.actualSales = Tools.roundMoney(
      $ctrl.dialogCtrl.summary.actualSales
    );
    $ctrl.dialogCtrl.summary.actualCosts = Tools.roundMoney(
      $ctrl.dialogCtrl.summary.actualCosts
    );
  };
}

/*****************************************************************************
 * updateGrid */
/**
 * @ngdoc    function
 * @name     updateGrid
 * @methodOf csm.books.fundraisers.activity.controller:ActivityController
 * @description
 * Set the grid dataprovider based on the provided active tab index.
 *****************************************************************************/
/* @ngInject */ function updateGrid($ctrl, TabType) {
  return function () {
    /*------------------------------------------*/
    /* Summary tab has no grid to update, skip. */
    /*------------------------------------------*/
    if ($ctrl.dialogCtrl.getTabType() === TabType.SUMMARY) return;

    /*----------------------------------------------*/
    /* Update grid data source and total displayed. */
    /*----------------------------------------------*/
    $ctrl.gridData = $ctrl.forCosts
      ? $ctrl.dpActualCosts
      : $ctrl.dpActualSales;
    $ctrl.actualTotal = $ctrl.forCosts
      ? $ctrl.dialogCtrl.summary.actualCosts
      : $ctrl.dialogCtrl.summary.actualSales;
  };
}
